import React from 'react';

type LoadingBaseType = {
  loading?: boolean;
}

export function useLockInLoadedValue<T extends LoadingBaseType>(value: T): T {
  const [debouncedValue, setDebouncedValue] = React.useState<T>(value);
  const [isValueLockedIn, setIsValueLockedIn] = React.useState(false);

  if (!value.loading && !isValueLockedIn) {
    setDebouncedValue(value);
    setIsValueLockedIn(true);
  }

  React.useEffect(
    () => {
      return () => {
        setIsValueLockedIn(false);
      }
    }, [value.loading]);

  return debouncedValue;
}
